import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Menu} from "@headlessui/react";
import {ArrowLeftOnRectangleIcon, Cog6ToothIcon, FolderArrowDownIcon} from "@heroicons/react/24/outline";
import SwatchIcon from "@heroicons/react/24/outline/SwatchIcon";
import {checkPerm, classNames, openInNewTab} from "../../util/util-helpers";
import {logoutClear} from "../../../data/actions/user";
import {clearCookies} from "../../../util/util";
import LocalStorage from "../../../util/localStorage";
import {
    AcademicCapIcon,
    BuildingOfficeIcon,
    ClipboardDocumentCheckIcon,
    DevicePhoneMobileIcon, DocumentDuplicateIcon, InformationCircleIcon, LifebuoyIcon, LockClosedIcon, TicketIcon,
    UserCircleIcon
} from "@heroicons/react/20/solid";
import {showGlobalModal} from "../../../data/actions/ui";
import {CREATE_PERM, READ_PERM} from "../../../util/util-constants";
import Resources from "../../../data/services/resources";
import {checkFeatureFlag} from "../feature-flags";

export default function UserMenu({setIsThemeDialogOpen}) {
    const history = useHistory();
    const dispatch = useDispatch();
    const [isLoggingOut, setIsLoggingOut] = useState(false);

    // const ui = useSelector((state) => state.ui);
    const userNavigation = [
        {
            name: 'My profile',
            icon: "UserCircleIcon",
            url: '/profiles',
            perm: checkPerm(Resources.User, READ_PERM)
        },
        {
            name: 'Account',
            icon: "BuildingOfficeIcon",
            url: '/account',
            perm: checkPerm(Resources.Company, READ_PERM)
        },
        // {
        //     name: 'Settings',
        //     icon: "Cog6ToothIcon",
        //     url: '/settings',
        // },
        // {
        //     name: 'Users report',
        //     icon: "ClipboardDocumentCheckIcon",
        //     url: '/users-report',
        //     perm: checkPerm(Resources.UsersReport, READ_PERM)
        // },
        {
            name: 'Logged devices',
            icon: "DevicePhoneMobileIcon",
            url: '/logged-devices',
            perm: checkPerm(Resources.UserLoggedDevices, READ_PERM)
        },
        // {
        //     name: 'Documents',
        //     icon: "DocumentDuplicateIcon",
        //     url: '/documents',
        //     perm: checkPerm(Resources.Documents, READ_PERM)
        // },
        // {
        //     name: 'Download center',
        //     icon: "FolderArrowDownIcon",
        //     url: '/download-center',
        //     perm: checkFeatureFlag('InvoiceJobON')
        // },
        {
            name: 'About',
            icon: "InformationCircleIcon",
            dispatch: 'About'
        },
        // {
        //     key: 'knowledge_base',
        //     name: 'Knowledge base',
        //     icon: "AcademicCapIcon",
        //     dispatch: 'knowledgeBaseSlideOver'
        // },
        {
            name: 'Support',
            icon: "LifebuoyIcon",
            dispatch: 'ticketingModal',
            dispatchData: {
                'title': "Support"
            },
            perm: checkPerm(Resources.Tickets, CREATE_PERM)
        },
        // {
        //     name: 'Tickets',
        //     icon: "TicketIcon",
        //     url: '/ticketing',
        //     perm: checkPerm(Resources.Tickets, READ_PERM)
        // },
        {
            name: 'Change password',
            icon: "LockClosedIcon",
            dispatch: 'ChangePassword'
        },
        {
            name: 'Themes',
            icon: "SwatchIcon"
        },
        {
            name: 'Logout',
            icon: "ArrowLeftOnRectangleIcon"
        }
    ]

    const userIcons = {
        SwatchIcon: SwatchIcon,
        ArrowLeftOnRectangleIcon: ArrowLeftOnRectangleIcon,
        UserCircleIcon: UserCircleIcon,
        BuildingOfficeIcon: BuildingOfficeIcon,
        Cog6ToothIcon: Cog6ToothIcon,
        ClipboardDocumentCheckIcon: ClipboardDocumentCheckIcon,
        DevicePhoneMobileIcon: DevicePhoneMobileIcon,
        DocumentDuplicateIcon: DocumentDuplicateIcon,
        FolderArrowDownIcon: FolderArrowDownIcon,
        InformationCircleIcon: InformationCircleIcon,
        AcademicCapIcon: AcademicCapIcon,
        LifebuoyIcon: LifebuoyIcon,
        TicketIcon: TicketIcon,
        LockClosedIcon: LockClosedIcon
    };



    function handleUserMenuClick(item) {
        if ("Themes" === item.name) {
            setIsThemeDialogOpen(true);
        } else if (item.url) {
            history.push(item.url)
        } else if (item.dispatch) {
            dispatch(showGlobalModal(item.dispatch, item?.dispatchData ?? {}));
        } else if ("Logout" === item.name) {
            setIsLoggingOut(true);
        }
    }

    function handleMiddleButtonClick(item) {
        if ("Themes" === item.name) {
            setIsThemeDialogOpen(true);
        } else if (item.url) {
            openInNewTab(item.url)
        } else if (item.dispatch) {
            dispatch(showGlobalModal(item.dispatch, item?.dispatchData ?? {}));
        } else if ("Logout" === item.name) {
            setIsLoggingOut(true);
        }
    }

    useEffect(() => {
        if (isLoggingOut) {
            LocalStorage.remove('user');
            LocalStorage.remove('lookup');
            dispatch(logoutClear());
            history.push('/login');
            clearCookies();
        }
    }, [isLoggingOut, history, dispatch])

    return (
        <>
            {userNavigation.map((item) => {
                const Icon = userIcons[item.icon];

                return (
                    <Menu.Item key={item.name}>
                        {({active}) => {
                            return (
                                <button
                                    onClick={() => handleUserMenuClick(item)}
                                    onMouseDown={(e) => {
                                        if (e.button === 1) {
                                            handleMiddleButtonClick(item)
                                        }
                                    }}
                                    className={classNames(
                                        active ? 'bg-tm-gray-100' : '',
                                        'w-full block py-2 px-4 text-sm text-tm-gray-900'
                                    )}
                                >
                                    <div
                                        className="flex items-center">
                                        {!!item.icon && (
                                            <Icon
                                                className="h-5 w-5 mr-2 text-tm-gray-700 opacity-75"
                                                aria-hidden="true"/>
                                        )}

                                        {item.name}
                                    </div>
                                </button>
                            )
                        }}
                    </Menu.Item>
                )
            })
            }
        </>
    )
}